import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Link,
  Redirect,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import { Divider, EInputTemplate, Input } from '../../components'
import {
  Container,
  StyledData,
  StyledEntity,
  Image,
  Title,
  StyledTitle,
  SaveButton,
  DeleteButton,
  StyledContainer,
  Div,
  StyledField,
  StyledUnionField,
  StyledFieldText,
  StyledNameFieldText,
  StyledDiv,
} from './styled'
import { Assets } from '../../assets'
import { TForm, TChangeManagerValidationSchema, TAccess } from './types'
import { useTypedSelector, useValidation } from '../../hooks'
import { Log } from '../../utils'
import { RoutesTree } from '../../router'
import {
  clearAdminAction,
  deleteAdminAction,
  getAdminByIdAction,
  updateAdminAction,
} from '../../store'

const fieldName = {
  pets: 'Питомцы',
  customers: 'Пользователи',
  settings: 'Настройки',
  info: 'Информация',
  clinics: 'Клиники',
  complaint: 'Жалобы',
  proposal: 'Предложения',
  inaccuracy: 'Неточности',
  control: 'Контроль',
  places: 'Места',
  notifications: 'Уведомления',
  dashboard: 'Панель',
  regions: 'Регионы',
  feedback: 'Обратная связь',
  eventsboard: 'Аналитика трендов',
  categories: 'Категории',
  ads: 'Объявления',
}

// @ts-ignore
const AdminProfile: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [form, setForm] = useState<TForm>({
    name: null,
    email: null,
  })
  const [access, setAccess] = useState<TAccess>({
    pets: false,
    customers: false,
    settings: false,
    info: false,
    clinics: false,
    complaint: false,
    proposal: false,
    inaccuracy: false,
    control: false,
    places: false,
    notifications: false,
    dashboard: false,
    regions: false,
    feedback: false,
    eventsboard: true,
    categories: false,
    ads: false,
  })

  const history = useHistory()

  const dispatch = useDispatch()

  const { admin } = useTypedSelector(store => store.admins)
  const { user } = useTypedSelector(state => state.user)

  if (!user?.access?.settings) {
    return <Redirect to={RoutesTree.notFound.path} />
  }
  // eslint-disable-next-line
  const inputHandler = useCallback(
    e => {
      setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
    },
    [form],
  )
  // eslint-disable-next-line
  const schema = useMemo<TChangeManagerValidationSchema>(
    () => ({
      name: {
        condition: form.name
          ? form.name.length
            ? form.name.length >= 2
            : true
          : true,
        error: `Введите имя`,
      },
      email: {
        condition: form.email
          ? form.email.length
            ? form.email?.includes('@')
            : true
          : true,
        error: `Неверный формат email`,
      },
    }),
    [form],
  )

  const {
    validationSchema,
    disableValidation,
    validation,
    enableValidation,
    isEnabled,
    // eslint-disable-next-line
  } = useValidation(schema)

  const choose = (key: string, value: boolean) => {
    setAccess(prev => ({ ...prev, [key]: value }))
  }

  const generateAccess = () => {
    const adminAccess = []

    for (const [key, value] of Object.entries(access)) {
      adminAccess.push(
        <StyledField key={key}>
          {/* @ts-ignore */}
          <StyledFieldText>{fieldName[key]}</StyledFieldText>

          <StyledDiv>
            <>
              <input
                name={key}
                type="radio"
                checked={value}
                onChange={() => choose(key, true)}
              />
              <Divider width={190} />
              <input
                name={key}
                type="radio"
                onChange={() => choose(key, false)}
                checked={!value}
              />
            </>
          </StyledDiv>
        </StyledField>,
      )
    }
    return adminAccess
  }

  const onPressSaveChanges = async () => {
    try {
      enableValidation()
      await validation()

      const result = window.confirm('Обновить админа?')

      if (result) {
        dispatch(
          updateAdminAction({
            data: {
              access,
              email: form.email as string,
              name: form.name as string,
            },
            id,
            authorization: '',
          }),
        )
      }

      disableValidation()
    } catch (error) {
      Log.ruddy('Event: onPressSaveChanges')
    }
  }

  const onPressDeleteAdmin = async () => {
    try {
      const result = window.confirm('Удалить админа?')

      if (result) {
        dispatch(
          deleteAdminAction({
            authorization: '',
            id,
          }),
        )

        history.goBack()
      }
    } catch (error) {
      Log.ruddy('Event: onPressDeleteAdmin')
    }
  }
  // eslint-disable-next-line
  useEffect(() => {
    dispatch(getAdminByIdAction.request({ id, authorization: '' }))
    return () => {
      dispatch(clearAdminAction())
    }
  }, [id])
  // eslint-disable-next-line
  useEffect(() => {
    setForm({
      name: admin?.name ?? null,
      email: admin?.email ?? null,
    })
    setAccess({
      pets: admin?.access?.pets ?? false,
      customers: admin?.access?.customers ?? false,
      settings: admin?.access?.settings ?? false,
      info: admin?.access?.info ?? false,
      clinics: admin?.access?.clinics ?? false,
      complaint: admin?.access?.complaint ?? false,
      proposal: admin?.access?.proposal ?? false,
      inaccuracy: admin?.access?.inaccuracy ?? false,
      control: admin?.access?.control ?? false,
      places: admin?.access?.places ?? false,
      notifications: admin?.access?.notifications ?? false,
      dashboard: admin?.access?.dashboard ?? false,
      regions: admin?.access?.regions ?? false,
      feedback: admin?.access?.feedback ?? false,
      eventsboard: admin?.access?.eventsboard ?? false,
      categories: admin?.access?.categories ?? false,
      ads: admin?.access?.ads ?? false,
    })
  }, [admin])

  return (
    <Container>
      <StyledTitle>
        {Assets.LEFT_ARROW_ICON ? (
          <Link
            to={{
              pathname: RoutesTree.settings.path,
            }}
          >
            <Image src={Assets.LEFT_ARROW_ICON} />
          </Link>
        ) : (
          ''
        )}

        <Title>Профиль</Title>

        <Div> </Div>
      </StyledTitle>

      <Divider height={10} />

      <StyledData>
        <StyledEntity>
          <Input
            label="Имя"
            name="name"
            value={form.name ?? ''}
            placeholder="Your name"
            template={EInputTemplate.NAME}
            error={schema.name.error || ''}
            onChange={v => inputHandler(v)}
            isValid={!isEnabled || validationSchema.name}
          />
        </StyledEntity>

        <StyledEntity>
          <Input
            label="E-mail"
            name="email"
            value={form.email ?? ''}
            placeholder="Your Email"
            error={schema.email.error || ''}
            template={EInputTemplate.DEFAULT}
            onChange={v => inputHandler(v)}
            isValid={!isEnabled || validationSchema.email}
          />
        </StyledEntity>

        <StyledUnionField>
          <StyledField>
            <StyledFieldText>Доступ</StyledFieldText>
            <>
              <StyledNameFieldText>Разрешен</StyledNameFieldText>
              <StyledNameFieldText>Запрещен</StyledNameFieldText>
            </>
          </StyledField>
        </StyledUnionField>

        <Divider height={10} />

        <StyledUnionField>{generateAccess()}</StyledUnionField>

        <Divider height={10} />

        <StyledContainer>
          <DeleteButton onClick={onPressDeleteAdmin}>Удалить</DeleteButton>

          <SaveButton onClick={onPressSaveChanges}>Сохранить</SaveButton>
        </StyledContainer>

        <Divider height={10} />
      </StyledData>
    </Container>
  )
}

export default AdminProfile
